
const customFieldsTypes = {
  CUSTOM_FIELDS_RESOURCE_SET: 'CUSTOM_FIELDS_RESOURCE_SET',
};
export default customFieldsTypes;